import axios from 'axios'
import config from '../config'
import {
  Message
} from 'element-ui';
import {
  startLoading,
  endLoading
} from '../processing'
import qs from 'qs'
import quit from '@/common/quit.js'
axios.defaults.baseURL = config.baseURL

let base64 = ''

function authHeader() {
  return {
    'x-auth-token': localStorage.getItem('token')
  }
}
const handleError = (error) => {
  let response = error.response
  if (response && (response.status == 401 || response.status == 403)) {
    quit()
  } else {
    Message.error(error.response.data.message)
  }
}
export default {
  login: async (username, password) => {
    startLoading();
    try {
      let result = await axios.post('/login', qs.stringify({
        username,
        password
      }), {
        emulateJSON: true
      })
      endLoading()
      return result.headers['x-auth-token']
    } catch (error) {
      endLoading()
      Message.error('账号或密码错误，请重新登录')
    }
  },
  getHome: async () => {
    startLoading()
    try {
      let result = await axios.get('/home', {
        headers: authHeader()
      })
      endLoading()
      return result.data.user
    } catch (error) {
      endLoading()
      handleError(error)
    }
  },
  getSelf: async () => {
    startLoading()
    try {
      let result = await axios.get('/user/self', {
        headers: authHeader()
      })
      endLoading()
      return result.data
    } catch (error) {
      endLoading()
      handleError(error)
    }
  },
  findHospitalName: async () => {
    startLoading()
    try {
      let result = await axios.get('/agent/hospital', {
        headers: authHeader()
      })
      endLoading()
      return result.data
    } catch (error) {
      endLoading()
      handleError(error)
      // 返回空数组而非undefined，避免调用方拿到undefined导致状态污染
      return []
    }
  },
  RetrievePassword: async (type, data) => {
    startLoading();
    try {
      console.log('data', type, data)
      let result = undefined
      if (type === 'sendSms') {
        result = await axios.get(`/user/verification/code`, {
          params: data,
        })
      } else if (type === 'verifySms') {
        result = await axios.post('/user/verification/code', data, {})
      }
      endLoading()
      return result
    } catch (error) {
      endLoading()
      handleError(error)
    }
  },
  saveTestResult: async (data) => {
    startLoading()
    try {
      let result = await axios.post('user/vision/challenge', data, {
        headers: authHeader()
      })
      endLoading()
      return 'success'
    } catch (error) {
      endLoading()
      handleError(error)
    }
  },
  getAllLastedTestResult: async () => {
    startLoading()
    try {
      let result = await axios.get('user/vision/challenge/recently', {
        headers: authHeader()
      })
      endLoading()
      return result
    } catch (error) {
      endLoading()
      handleError(error)
    }
  },
  getPatientVisionChallenge: async (patientId, params) => {
    startLoading();
    try {
      const result = await axios.get(`/user/${patientId}/vision/challenge`, {
        headers: authHeader(),
        params,
      })
      endLoading()
      return result.data
    } catch (error) {
      endLoading()
      handleError(error)
    }
  },

  // 上传PDF报告到服务器
  uploadPdfReport: async (patientName, gender, birthday, hospital, stationId, items, reportFile) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append('patientName', patientName);
      formData.append('gender', gender);
      formData.append('birthday', birthday);
      formData.append('hospital', hospital);
      if (stationId) {
        formData.append('stationId', stationId);
      }
      items.forEach(item => {
        formData.append('items', item);
      });
      formData.append('report', reportFile);

      let result = await axios.post('/testing/save', formData, {
        headers: {
          ...authHeader(),
          'Content-Type': 'multipart/form-data'
        }
      });

      endLoading();
      return result.status === 200; // 返回200就算成功
    } catch (error) {
      endLoading();
      handleError(error);
      return null;
    }
  },

  // 查询患者列表
  queryPatients: async (params) => {
    startLoading();
    try {
      let result = await axios.get('/testing/query', {
        headers: authHeader(),
        params: params
      });
      endLoading();
      return result.data;
    } catch (error) {
      endLoading();
      handleError(error);
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/http/componentsAPI/admin.js